import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RoutesKeys } from 'src/app/utils/routes';
import errors from '../../errors/errors';

@Injectable()
/**
 *  AuthInterceptor is an interceptor responsible to automatically add the user
 *  token in all requests that are made and to redirect the user to the login
 *  page if the token is not valid
 */
export class AuthInterceptor implements HttpInterceptor {
  /**
   *  Constructor
   * @constructor
   */
  constructor(private router: Router) {}

  /**
   *   Build the interceptor
   *
   *  @param {HttpRequest<any>} request request made by the user
   *  @param {HttpHandler} next next function in chain
   *  @return {Observable<HttpEvent<any>>}
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('s3') && request.url.includes('amazonaws.com')) {
      // do not add headers to s3 requests
      return next.handle(request);
    }

    const currentUser: any = JSON.parse(
      localStorage.getItem('okta-token-storage') || '{}'
    );

    if (currentUser && currentUser.accessToken?.accessToken) {
      const authHeader = `Bearer ${currentUser.accessToken.accessToken}`;
      request = request.clone({
        setHeaders: {
          Authorization: authHeader,
          'Content-Type': 'application/json',
          'Cache-Control':
            'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          this.router.navigate([RoutesKeys.HOME]);
        }
        let error: any;
        if (err.error && err.error.errorCode) {
          error = errors.get(err.error.errorCode);
        } else {
          error = errors.get(`HTTP-${err.status}`);
        }
        if (error instanceof Error) {
          throw error;
        }
        throw err;
      })
    );
  }
}
